import { ModalWindow } from '@/components/ModalWindow/ModalWindow';
import { Box } from '@/components/Box/Box';
import { Button } from '@/components/Button/Button';
import WarningSecondaryIcon from '@/images/WarningSecondaryIcon.svg?react';
import { Typography } from '@/components/Typography/Typography';
import { COLORS } from '@/styles/colors';
import {
  Divider,
  SuccessModalValue,
} from '@/bundle/_MasterAdmin/_DevelopersPage/CreateApiKeyForm/ui/SuccessApiKeyCreatedModal/styles';
import { DetailsRow } from '@/components/DetailsWidget/DetailsRow/DetailsRow';
import { ClipBoardButton } from '@/bundle/_MasterAdmin/_DevelopersPage/CreateApiKeyForm/ui/SuccessApiKeyCreatedModal/ClipBoardButton';
import { CreatedApiKeyType } from '@/api/v1/api-key/createApiKeyApi';
import { formatDate } from '@/helpers/dateHelpers/dateHelpers';
import { copyToClipboard } from '@/helpers/helpers';

type SuccessApiKeyCreatedModalType = {
  isOpen: boolean;
  onClose: () => void;
  apiKeyData: CreatedApiKeyType;
};

export const SuccessApiKeyCreatedModal = ({ isOpen, onClose, apiKeyData }: SuccessApiKeyCreatedModalType) => {
  const save = async (message: string) => {
    copyToClipboard(message);
  };

  const expirationDate = formatDate(apiKeyData?.date_expired);

  return (
    <ModalWindow isOpen={isOpen} width='504px'>
      <Box display='flex' flexDirection='column' rowGap='28px'>
        <Box display='flex' flexDirection='column' rowGap='20px' alignItems='center'>
          <WarningSecondaryIcon />
          <Box display='flex' flexDirection='column' alignItems='center' rowGap='14px'>
            <Typography variant='headline4' fontWeight='semibold' color={COLORS.black}>
              API Key Created
            </Typography>
            <Typography color={COLORS.grey[950]}>Here is your new API key.</Typography>
            <Box display='flex' flexDirection='column' width='100%' rowGap='14px'>
              <Divider />
              <Box display='flex' flexDirection='column' rowGap='8px'>
                <Box
                  display='flex'
                  flexDirection='row'
                  alignItems='center'
                  justifyContent='space-between'
                  columnGap='4px'
                >
                  <Typography variant='bodySmall' color={COLORS.grey[600]}>
                    API Key ID
                  </Typography>
                  <Box display='flex' alignItems='center' columnGap='8px'>
                    <ClipBoardButton tooltipMessage={apiKeyData?.id} onClick={save} />
                    <SuccessModalValue>{apiKeyData?.id}</SuccessModalValue>
                  </Box>
                </Box>
                <Box
                  display='flex'
                  flexDirection='row'
                  alignItems='center'
                  justifyContent='space-between'
                  columnGap='4px'
                >
                  <Typography variant='bodySmall' color={COLORS.grey[600]}>
                    API Key
                  </Typography>
                  <Box display='flex' alignItems='center' columnGap='8px'>
                    <ClipBoardButton tooltipMessage={apiKeyData?.key} onClick={save} />
                    <SuccessModalValue>{apiKeyData?.key}</SuccessModalValue>
                  </Box>
                </Box>
                <DetailsRow name='Expiration Date'>{expirationDate}</DetailsRow>
              </Box>
              <Divider />
            </Box>
            <Typography color={COLORS.grey[950]} textAlign='center'>
              Please make sure to copy it now and keep it somewhere safe. To protect your data, we cannot show this to
              you again once you close this modal window. If it slips away, don`t worry - you can always create a new
              one.
            </Typography>
          </Box>
        </Box>
        <Button onClick={onClose}>Return to API Keys</Button>
      </Box>
    </ModalWindow>
  );
};
